import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

let routes = [
	{
		path: '*',
		component: () => import('../views/404.vue'),
	},
	{
		path: '/',
		name: 'Index',
		redirect: '/index',
	},
    {
		path: '/Index',
		name: 'CustomerPortal',
		component: () => import('../views/Index.vue'),
        meta: {
            name: "首页",
            enName: 'Customer Portal'
        }
	},
    {
		path: '/user',
        redirect: '/user/info',
		layout: "dashboard",
		component: () => import('../views/User.vue'),
        meta: {
            requiresAuth: true
        },
        children: [
            {
                path: 'info',
                name: 'Home',
                component: () => import('../views/user/CustomerPortal.vue'),
                meta: {
                    requiresAuth: true,
                    name: "会员中心",
                    enName: 'Home'
                },
            },

            {
                path: 'package_forecast',
                name: 'PackageDeclaration',
                component: () => import('../views/user/package/PackageDeclare.vue'),
                meta: {
                    requiresAuth: true,
                    name: "添加包裹",
                    enName: 'Package declaration'
                },
            },

            {
                path: 'package_forecast/edit',
                name: 'PackageDeclarationEdit',
                component: () => import('../views/user/package/PackageDeclare.vue'),
                meta: {
                    requiresAuth: true,
                    name: "编辑包裹",
                    enName: 'Package declaration'
                },
            },

            {
                path: '/user/create_shipment',
                name: 'CreateShipment',
                component: () => import('../views/user/package/CreateShipment.vue'),
                meta: {
                    requiresAuth: true,
                    name: "提交转运",
                    enName: 'Create Shipment'
                },
            },

            {
                path: 'package_forecast/view',
                name: 'CreateShipmentDetails',
                component: () => import('../views/user/package/View.vue'),
                meta: {
                    requiresAuth: true,
                    name: "详情",
                    enName: 'Create Shipment details'
                },
            },

            {
                path: 'submit_transfer',
                name: 'SubmitTransfer',
                component: () => import('../views/user/package/SubmitTransfer.vue'),
                meta: {
                    requiresAuth: true,
                    name: "提交转运",
                    enName: 'Create Shipment'
                },
            },

            {
                path: 'submit_back_package',
                name: 'PackageReturn',
                component: () => import('../views/user/package/PackageReturn.vue'),
                meta: {
                    requiresAuth: true,
                    name: "退运",
                    enName: 'Package Return'
                },
            },

            {
                path: 'order',
                name: 'Shipments',
                component: () => import('../views/user/order/Shipment.vue'),
                meta: {
                    requiresAuth: true,
                    name: "我的转运",
                    enName: 'Shipments'
                },
            },

            {
                path: 'order/view',
                name: 'ShipmentsDetails',
                component: () => import('../views/user/order/View.vue'),
                meta: {
                    requiresAuth: true,
                    name: "详情",
                    enName: 'Shipments details'
                },
            },

            {
                path: 'return',
                name: 'ParcelReturn',
                component: () => import('../views/user/return/ParcelReturn.vue'),
                meta: {
                    requiresAuth: true,
                    name: "退运包裹",
                    enName: 'Parcel Return'
                },
            },

            {
                path: 'return/view',
                name: 'ParcelReturnDetails',
                component: () => import('../views/user/return/View.vue'),
                meta: {
                    requiresAuth: true,
                    name: "详情",
                    enName: 'Parcel Return details'
                },
            },

            {
                path: 'addr',
                name: 'AddressBook',
                layout: "dashboard",
                component: () => import('../views/user/Address.vue'),
                meta: {
                    requiresAuth: true,
                    name: "收件地址",
                    enName: 'Address book'
                },
            },

            {
                path: 'profile',
                name: 'Profile',
                component: () => import('../views/user/Profile.vue'),
                meta: {
                    requiresAuth: true,
                    name: "会员信息",
                    enName: 'Profile'
                },
            },

            {
                path: 'member_balance',
                name: 'CreditLog',
                component: () => import('../views/user/CreditLogs.vue'),
                meta: {
                    requiresAuth: true,
                    name: "余额记录",
                    enName: 'Credit Log'
                },
            },

            {
                path: 'message',
                name: 'Message',
                layout: "dashboard",
                component: () => import('../views/user/message/Message.vue'),
                meta: {
                    requiresAuth: true,
                    name: "站内信",
                    enName: 'Message'
                },
            },

            {
                path: 'message_reply',
                name: 'MessageReply',
                layout: "dashboard",
                component: () => import('../views/user/message/View.vue'),
                meta: {
                    requiresAuth: true,
                    name: "查看回复信息",
                    enName: 'Message Reply'
                },
            },

            {
                path: 'package/view',
                name: 'ShippingInformation',
                layout: "dashboard",
                component: () => import('../views/user/PackageDetail.vue'),
                meta: {
                    requiresAuth: true,
                    name: "物流信息",
                    enName: 'Shipping information'
                },
            },

            {
                path: 'balance_recharge',
                name: 'Recharge',
                layout: "dashboard",
                component: () => import('../views/user/Recharge.vue'),
                meta: {
                    requiresAuth: true,
                    name: "会员充值",
                    enName: 'Recharge'
                },
            },

            {
                path: 'coupon',
                name: 'Coupon',
                layout: "dashboard",
                component: () => import('../views/user/coupon/CouponList.vue'),
                meta: {
                    requiresAuth: true,
                    name: "会员优惠券",
                    enName: 'Coupon'
                },
            },
            {
                path: 'coupon/view',
                name: 'CouponView',
                layout: "dashboard",
                component: () => import('../views/user/coupon/View.vue'),
                meta: {
                    requiresAuth: true,
                    name: "详情",
                    enName: 'Details'
                },
            },
            {
                path: 'get_coupon',
                name: 'GetCoupon',
                layout: "dashboard",
                component: () => import('../views/user/coupon/GetCoupon.vue'),
                meta: {
                    requiresAuth: true,
                    name: "领取优惠券",
                    enName: 'Get coupons'
                },
            },

        ]
	},

    {
        path: '/payment',
		layout: "dashboard",
		component: () => import('../views/Payment.vue'),
        meta: {
            requiresAuth: true
        },
        children: [
            {
                path: 'cpay/:payment_id',
                name: 'Payment',
                component: () => import('../views/payment/Pay.vue'),
            },
            {
                path: 'paypal',
                name: 'Paypal',
                component: () => import('../views/payment/PayPal.vue')
            },
            {
                path:'stripe_pay_view',
                name: 'StripePayView',
                component: () => import('../views/payment/PayStripe.vue')
            },
            {
                path:'success',
                name: 'PaymentSuccess',
                component: () => import('../views/payment/Success.vue'),
            },
        ]
    },
    

	{
		path: '/login',
		name: 'Sign-In',
		component: () => import('../views/SignIn.vue'),
	},
    {
		path: '/calc_freight',
		name: 'CalcFreight',
		component: () => import('../views/CalcFreight.vue'),
	},
	{
		path: '/register',
		name: 'Sign-Up',
		component: () => import('../views/SignUp.vue'),
	},
    {
		path: '/password',
		name: 'Password',
		component: () => import('../views/ResetPassword.vue'),
	},
    {
		path: '/track',
		name: 'Track',
		component: () => import('../views/Track.vue'),
	},
    
    {
		path: '/contact',
		name: 'Contact us',
		component: () => import('../views/Contact.vue'),
	},
    {
        path: '/page/alist/:cate_id',
        name: 'ArticleList',
        component: () => import('../views/article/ArticleList')
    },
    {
        path: '/p/:aid',
        name: 'ArticleDetail',
        component: () => import('../views/article/ArticleDetail'),
        meta: {
            hideFooter: true,
        },
    },
]


function addLayoutToRoute( route, parentLayout = "default" ) {
	route.meta = route.meta || {} ;
	route.meta.layout = route.layout || parentLayout ;
	
	if( route.children )
	{
		route.children = route.children.map( ( childRoute ) => addLayoutToRoute( childRoute, route.meta.layout ) );
	}
	return route ;
}

routes = routes.map( ( route ) => addLayoutToRoute( route ) ) ;

const router = new VueRouter({
	mode: 'hash',
	base: process.env.BASE_URL,
	routes,
	scrollBehavior (to, from, savedPosition) {
		if ( to.hash ) {
			return {
				selector: to.hash,
				behavior: 'smooth',
			}
		}
		return {
			x: 0,
			y: 0,
			behavior: 'smooth',
		}
	},
})

// router.beforeEach( ( to, from, next ) => {
//     if(to.name=='Sign-In' || to.name=='Sign-Up') {
//         if(localStorage.getItem('mtoken')) {
//             next({ name: 'Home' });
//         }
//     }else {
//         next();
//     }
// })

export default router
